import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { EmptyClientList } from "../../assets/images";
import {
  ChangeClientStatusChangePayloadType,
  EmailHistoryPayload,
  GetClientDirectoryListPayloadType,
  SendEmailPayload,
} from "../../commonTypes/clientDirectoryTypes";
import { GetAllMasterDataBranchPayloadType, GetClientCategoryPayloadType, GetUsersDepartmentPayloadType } from "../../commonTypes/masterDataTypes";
import ClientModuleEmailModal from "../../components/ClientDirectory/CientModuleEmailModal/ClientModuleEmailModal";
import ClientDirectoryFilter from "../../components/ClientDirectory/ClientDirectoryFilter";
import ClientDirectoryTable from "../../components/ClientDirectory/ClientDirectoryTable/ClientDirectoryTable";
import ClientDownloadReport from "../../components/ClientDirectory/ClientDownloadReport";
import ClientDirectoryListSorting from "../../components/ClientDirectory/ClientListSorting";
import { SelctOptionType } from "../../components/DisbursementModule/DisbursementModuleForm/AddEditDisbursementForm";
import { SearchIcon } from "../../components/Icon";
import {
  CommonHeader,
  ConfirmationModal,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
  TableLoader,
} from "../../components/commons";
import { CLIENT_DIRECTORY_HEADERS } from "../../constant/tableHeadersConstants/clientDirectoryConstant/clientDirectoryHeaders";
import useDebounce from "../../customHooks/useDebounce";
import { useMenuCheck } from "../../customHooks/useMenuCheck";
import { resetSession } from "../../redux/auth";
import { LoginResponseType } from "../../redux/auth/authTypes";
import {
  resetClientDirectoryError,
  resetClientDirectoryList,
  resetClientDirectoryMessage,
  resetClientDirectoryStatusCode,
  resetClientDirectorySuccess,
  resetClientDirectoryTotalCount,
  resetClientStatusSuccess,
  resetLeadClientEmailHistory,
  resetLeadEmailFetching,
} from "../../redux/clientDirectory";
import {
  changeClientStatusAction,
  clientSentEmailAction,
  getClientDirectoryListAction,
  leadClientSentEmailHistoryAction,
} from "../../redux/clientDirectory/action";
import { ClientDirectoryListType } from "../../redux/clientDirectory/clientDirectoryType";
import { getAllMasterDataBranchAction, getMasterDataClientCategoryAction, getMasterDataScopeOfWorkAction, resetMasterDataLisitng } from "../../redux/masterData";
import { ClientCategoryListType, ScopeOfWorkListType } from "../../redux/masterData/masterTypes";
import { RootState } from "../../redux/rootReducers";
import ClientCategoryFilter from "../../components/MasterData/ClientCategoryTable/ClientCategoryFilter";
type AppProps = {
  history: any;
  token: string | null;
  message: string | null;
  error: string | null;
  success: number | null;
  clientStatusSuccess: number | null;
  statusCode: number | null;
  fetching: boolean;
  clientDirectoryList: [] | ClientDirectoryListType[];
  totalCount: number | null;
  dispatchResetClientDirectorySuccess: () => void;
  dispatchResetClientDirectoryError: () => void;
  dispatchResetClientDirectoryMessage: () => void;
  dispatchResetClientDirectoryStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientStatusSuccess: () => void;
  dispatchResetClientDirectoryList: () => void;
  dispatchResetClientDirectoryTotalCount: () => void;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  dispatchChangeClientStatusAction: (
    data: ChangeClientStatusChangePayloadType
  ) => void;
  loginData: LoginResponseType;
  leadClientEmailHistory: [] | any;
  dispatchSentEmailAction: (data: SendEmailPayload) => void;
  dispatchResetLeadEmailHistory: () => void;
  dispatchEmailHistoryAction: (data: EmailHistoryPayload) => void;
  emailFetching: boolean;
  clientCategoryList: ClientCategoryListType[] | [];
  clientCategoryTotalCount: number;
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => void;
  scopeOfWorkList: ScopeOfWorkListType[] | [];
  scopeOfWorkTotalCount: number;
  masterDataBranchListTotal: string | number;
  dispatchGetMasterDataScopeOfWorkAction:(data:GetUsersDepartmentPayloadType)=>void;
  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) =>void;
  dispatchResetMasterDataListing: () => void;
  masterDataListing: [];
};
const ClientDirectory = ({
  history,
  token,
  statusCode,
  success,
  message,
  fetching,
  error,
  clientCategoryList,
  clientCategoryTotalCount,
  dispatchGetMasterDataClientCategoryAction,
  dispatchResetClientDirectorySuccess,
  dispatchResetClientDirectoryError,
  dispatchResetClientDirectoryMessage,
  dispatchResetClientDirectoryStatusCode,
  dispatchResetSession,
  clientDirectoryList,
  totalCount,
  dispatchGetClientDirectoryListAction,
  dispatchResetClientDirectoryList,
  dispatchResetClientDirectoryTotalCount,
  dispatchChangeClientStatusAction,
  dispatchResetClientStatusSuccess,
  clientStatusSuccess,
  loginData,
  leadClientEmailHistory,
  dispatchSentEmailAction,
  dispatchResetLeadEmailHistory,
  dispatchEmailHistoryAction,
  emailFetching,
  scopeOfWorkList,
  scopeOfWorkTotalCount,
  dispatchGetMasterDataScopeOfWorkAction,
  dispatchGetAllMasterDataBranchListAction,
  dispatchResetMasterDataListing,
  masterDataBranchListTotal,
  masterDataListing
}: AppProps) => {
  const persistSearch = history?.location?.state?.searchValue
    ? history?.location?.state?.searchValue
    : "";
  const [searchValue, setSearchValue] = useState(persistSearch);
  const [contactTypeData, setContactTypeData] = useState<any>([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [clientDirectoryListData, setClientDirectoryListData] = useState<any>(
    []
  );
  const [selectedFilter, setSelectedFilter] = useState({
    name: "All Contact Type",
    value: "",
  });
  const [showIsClientSendEmail, setShowIsClientSendEmail] = useState(false);
  const [showIsClientSendEmailData, setShowIsClientSendEmailData] =
    useState<any>(null);
  const [isEmailError, setIsEmailError] = useState<string>("");
  const [clientEmailText, setClientEmailText] = useState("");
  const [data, setData] = useState<any>([]);
  const [sortByName, setSortByName] = useState({ name: "", value: "" });
  const [sortByCc, setSortByCc] = useState({ name: "", value: "" });
  const [sortByCf, setSortByCf] = useState({ name: "", value: "" });
  const [sortByRecent, setSortByRecent] = useState({ name: "", value: "" });
  const [isAddClientPresent, setIsAddClientPresent] = useMenuCheck();
  const [isEditClientPresent, setIsEditClientPresent] = useMenuCheck();
  const [isViewClientPresent, setIsViewClientPresent] = useMenuCheck();
  const [isEmailClientPresent, setIsEmailClientPresent] = useMenuCheck();
  const [isViewOnlyClientPresent, setIsViewOnlyClientPresent] = useMenuCheck();
  const [isDownloadReportPresent, setIsDownloadReportPresent] = useMenuCheck();
  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [clientStatusData, setClientStatusData] = useState<any>({
    name: "",
    is_active: null,
    clientCode: null,
  });
  // category filter
  const [clientCategoryFilter, setClientCategoryFilter] = useState<
    any
  >([]);
  const [selectedClientCategoryFilter, setSelectedClientCategoryFilter] =
    useState<any>([]);
  const [categoryOffset, setCategoryOffset] = useState<number>(0);
  const [categoryLimit, setCategoryLimit] = useState<number>(20);
  const [categoryText, setCategoryText] = useState("");
  const [finalCategoryFilterList, setFinalCategoryFilterList] = useState<any>(
    []
  );
  // scope of work filter
  const [scopeofWorkFilter, setScopeofWorkFilter] = useState<
  any
  >([]);
  const [branchFilter, setBranchFilter] = useState<any>({
    label:"Select Branch...",
    value:"",
  });

    const [filterCount, setFilterCount] = useState<any>({
      clientCategory: "",
      scopeOfWork: "",
      branch: "",
    });

  const [selectedScopeofWorkFilter, setSelectedScopeofWorkFilter] =
  useState<any>([]);
  const [scopeofWorkOffset, setscopeofWorkOffset] = useState<number>(0);
  const [scopeLimit, setscopeLimit] = useState<number>(20);
  const [scopeofWorkText, setScopeofWorkText] = useState("");
  const [finalScopeofWorkFilterList, setFinalScopeofWorkFilterList] = useState<any>(
    []
  );

  const [filter, setFilter] = useState<number | null | undefined>(null);
  const [apply, setApply] = useState(false);
  const [handlestate, setHandleState] = useState();
  const [handleScopeofWorkState , setHandleScopeofWorkState]= useState();
  const [locationOffset, setLocationOffset] = useState(0);
  const [locationLimit, setLocationLimit] = useState(20);
  const [locationText, setLocationText] = useState("");
  const [branchFinalData, setBranchFinalData] = useState<any>([]);

  const { pathname } = useLocation();
  const isView = pathname?.includes("view");
  const assignedPathName = pathname?.includes("assigned-client-directory");
  const persistSortByCc = history?.location?.state?.sortByCc
    ? history?.location?.state?.sortByCc
    : { name: "", value: "" };
  const persistSortByCf = history?.location?.state?.sortByCf
    ? history?.location?.state?.sortByCf
    : { name: "", value: "" };
  const persistSortByName = history?.location?.state?.sortByName
    ? history?.location?.state?.sortByName
    : { name: "", value: "" };
  const persistCategory = history?.location?.state?.persistCategory
    ? history?.location?.state?.persistCategory
    : [];
  const persistcategoryFilter = history?.location?.state?.persistcategoryFilter
    ? history?.location?.state?.persistcategoryFilter
    : [];
  const persistBranchFilter = history?.location?.state?.persistBranchFilter? history?.location?.state?.persistBranchFilter : { label: "Select Branch...", value: "" }
  const persistScope= history?.location?.state?.persistScope? history?.location?.state?.persistScope:[];
  const persistScopeFilter= history?.location?.state?.persistScopeFilter ? history?.location?.state?.persistScopeFilter:[];
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    setOffset(0);
    setIsAddClientPresent("Add Client Directory", "menu");
    setIsEditClientPresent("Edit Client Directory", "menu");
    setIsViewClientPresent("View Client Directory", "menu");
    setIsEmailClientPresent("Send Client Email", "menu");
    setIsViewOnlyClientPresent("Client Directory ", "menu");
    setIsDownloadReportPresent("Client Directory Download Report", "menu");
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    dispatchResetClientDirectoryList();
    dispatchResetClientDirectoryTotalCount();
    dispatchResetClientStatusSuccess();
    dispatchResetMasterDataListing()
    setData([
      { name: "", value: "" },
      { name: "Name - A to Z Order", value: "asc" },
      { name: "Name - Z to A Order", value: "desc" },
      { name: "Client Code - Ascending", value: "asc" },
      { name: "Client Code - Descending", value: "desc" },
      { name: "Client From - Ascending", value: "asc" },
      { name: "Client From - Descending", value: "desc" },
    ]);
    setContactTypeData([
      { name: "All Contact Type", value: "" },
      { name: "Filter By Lead", value: "Lead" },
      { name: "Filter By Client", value: "Client" },
      { name: "Filter By Prospect", value: "Prospect" },
      { name: "Filter By Supplier", value: "Supplier" },
      { name: "Filter By Other", value: "Other" },
      { name: "Filter By Client & Supplier", value: "Client & Supplier" },
      { name: "Filter By Prospect & Supplier", value: "Prospect & Supplier" },
      { name: "Filter By Lead & Supplier", value: "Lead & Supplier" },
    ]);
    if (persistSortByCc?.name) {
      setSortByCc({
        ...persistSortByCc,
      });
      setSortByCf({ name: "", value: "" });
      setSortByName({ name: "", value: "" });
    } else if (persistSortByCf?.name) {
      setSortByCf({
        ...persistSortByCf,
      });
      setSortByCc({ name: "", value: "" });
      setSortByName({ name: "", value: "" });
    } else if (persistSortByName?.name) {
      setSortByName({
        ...persistSortByName,
      });
      setSortByCc({ name: "", value: "" });
      setSortByCf({ name: "", value: "" });
    }
    if (persistCategory?.length > 0 ||persistScope?.length>0||persistBranchFilter?.value) {
      setSelectedClientCategoryFilter(persistCategory? persistCategory:[]);
      setClientCategoryFilter(
        persistcategoryFilter?.length ? [...persistcategoryFilter] : []
      );    
      setHandleState(persistCategory?persistCategory:[])
      if(persistScope?.length>0 || persistScopeFilter?.length){      
        setSelectedScopeofWorkFilter(persistScope?persistScope:[]);
        setScopeofWorkFilter(persistScopeFilter?.length ?  [...persistScopeFilter]:[])
        setHandleScopeofWorkState(persistScope?persistScope:[])

      }
      if(persistBranchFilter?.value){
        setBranchFilter(persistBranchFilter)
      }
      setApply(true);
    }
  }, []);
 
useEffect(()=>{
  setFilterCount({
    clientCategory: clientCategoryFilter?.length?1:0,
    scopeOfWork: scopeofWorkFilter?.length?1:0,
    branch: branchFilter?.value?1:0,
  });
},[branchFilter,clientCategoryFilter,scopeofWorkFilter])

  useEffect(() => {
    if (clientDirectoryList?.length === 0) {
      setClientDirectoryListData(clientDirectoryList);
    } else if (offset > 0 && clientDirectoryList?.length > 0 && !fetching) {
      setClientDirectoryListData((prv: any) => [
        ...prv,
        ...clientDirectoryList,
      ]);
    } else {
      setClientDirectoryListData(clientDirectoryList);
    }
  }, [clientDirectoryList]);

  useEffect(() => {
    delete history?.location?.state?.persistCategory;
    delete history?.location?.state?.persistcategoryFilter;
    delete history?.location?.state?.persistScope;
    delete history?.location?.state?.persistScopeFilter;
    delete history?.location?.state?.persistBranchFilter;
    if (token && totalCount) {
      let finalData = {
        token,
        offset,
        limit,
        clientCode: sortByCc?.value ? sortByCc?.value : persistSortByCc?.value,
        name: sortByName?.value ? sortByName?.value : persistSortByName?.value,
        clientFrom: sortByCf?.value ? sortByCf?.value : persistSortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        isView: assignedPathName ? true : false,
        branch_id: branchFilter?.value ? branchFilter?.value : persistBranchFilter?.value,
        client_category: `${
          !!selectedClientCategoryFilter[0]
            ? selectedClientCategoryFilter?.join()
            : persistCategory
        }`,
        scope_of_work:`${
          !!selectedScopeofWorkFilter[0]
            ? selectedScopeofWorkFilter?.join()
            : persistScope
        }`
      };
      if (offset < totalCount) {
        dispatchGetClientDirectoryListAction(finalData);
      }
    } else if ((offset === 0 && totalCount === null) || totalCount === 0) {
      let finalData = {
        token,
        offset,
        limit,
        clientCode: sortByCc?.value ? sortByCc?.value : persistSortByCc?.value,
        name: sortByName?.value ? sortByName?.value : persistSortByName?.value,
        clientFrom: sortByCf?.value ? sortByCf?.value : persistSortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        isView: assignedPathName ? true : false,
        branch_id: branchFilter?.value ? branchFilter?.value : persistBranchFilter?.value,
        client_category: `${
          !!selectedClientCategoryFilter[0]
            ? selectedClientCategoryFilter?.join()
            : persistCategory
        }`,
        scope_of_work:`${
          !!selectedScopeofWorkFilter[0]
            ? selectedScopeofWorkFilter?.join()
            : persistScope
        }`,
        
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  }, [offset]);

  useEffect(() => {
    const finalBranchData = masterDataListing?.map((user: any) => {
      return {
        value: user?._id,
        label: user?.branch_name,
      };
    });
    if (locationOffset > 0 && masterDataListing?.length) {
      setBranchFinalData([...branchFinalData, ...finalBranchData]);
    } else {
      setBranchFinalData(finalBranchData);
    }
  }, [masterDataListing]);

  useEffect(() => {
      if (token) {
        let finalUserData = {
          token,
          offset: locationOffset,
          limit: locationLimit,
          search_term: locationText,
        };
        if (locationOffset <= +masterDataBranchListTotal) {
          dispatchGetAllMasterDataBranchListAction(finalUserData);
        }
      }
    }, [locationOffset]);

    const fetchNewBranchData = (search: string) => {
      const finalData = {
        token,
        offset: locationOffset,
        limit: locationLimit,
        search_term: locationText,
      };
      dispatchGetAllMasterDataBranchListAction(finalData);
    };
  
    useDebounce(
      () => {
        if (locationText) {
          fetchNewBranchData(locationText);
        } else if (locationOffset > 0) {
          setLocationOffset(0);
        } else {
          const finalData = {
            token,
            offset: locationOffset,
            limit: locationLimit,
            search_term: locationText,
          };
          dispatchGetAllMasterDataBranchListAction(finalData);
        }
      },
      500,
      [locationText]
    );
  

  //infinite Scroll
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (
        !fetching &&
        clientDirectoryList?.length > 0 &&
        totalCount &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        setOffset(offset + limit);
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [clientDirectoryList]);

  useEffect(() => {
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    dispatchResetClientDirectoryList();
    dispatchResetClientDirectoryTotalCount();
    setOffset(0);
    if (token && contactTypeData) {
      let params = {
        token,
        offset,
        limit,
        clientCode: sortByCc?.value,
        name: sortByName?.value,
        ClientFrom: sortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        isView: assignedPathName ? true : false,
        client_category: selectedClientCategoryFilter.join(","),
        scope_of_work:selectedScopeofWorkFilter?.join(",")
      };
      // dispatchGetClientDirectoryListAction(params);
    }
  }, [selectedFilter?.value]);

  const fetchNewData = (search: string) => {
    if (token && searchValue) {
      const finalData = {
        token,
        offset,
        limit,
        clientCode: sortByCc?.value ? sortByCc?.value : persistSortByCc?.value,
        name: sortByName?.value ? sortByName?.value : persistSortByName?.value,
        clientFrom: sortByCf?.value ? sortByCf?.value : persistSortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        isView: assignedPathName ? true : false,
        branch_id: branchFilter?.value ? branchFilter?.value : persistBranchFilter?.value,
        client_category: `${
          !!selectedClientCategoryFilter[0]
            ? selectedClientCategoryFilter?.join()
            : persistCategory
        }`,
        scope_of_work:`${
          !!selectedScopeofWorkFilter[0]
            ? selectedScopeofWorkFilter?.join()
            : persistScope
        }`
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData(searchValue);
      }
    },
    500,
    [searchValue]
  );

  // client category filter

  useEffect(() => {
    const finalData = {
      token,
      limit: categoryLimit,
      offset: categoryOffset,
      search_term: categoryText,
      status: 1,
    };
    dispatchGetMasterDataClientCategoryAction(finalData);
  }, []);

  useEffect(() => {
    const finalCategoryData = clientCategoryList?.map((user: any) => {
      return {
        value: user?._id,
        label: user?.name_of_category,
      };
    });
    if (categoryOffset > 0) {
      setFinalCategoryFilterList([
        ...finalCategoryFilterList,
        ...finalCategoryData,
      ]);
    } else {
      setFinalCategoryFilterList(finalCategoryData);
    }
  }, [clientCategoryList]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        limit: categoryLimit,
        offset: categoryOffset,
        search_term: categoryText,
        status: 1,
      };
      if (categoryOffset <= clientCategoryTotalCount) {
        dispatchGetMasterDataClientCategoryAction(finalUserData);
      }
    }
  }, [categoryOffset]);

  const fetchNewCategoryData = (search: string) => {
    const finalData = {
      token,
      limit: categoryLimit,
      offset: categoryOffset,
      search_term: categoryText,
      status: 1,
    };
    dispatchGetMasterDataClientCategoryAction(finalData);
  };

  useDebounce(
    () => {
      if (categoryText) {
        fetchNewCategoryData(categoryText);
      } else {
        const finalData = {
          token,
          limit: categoryLimit,
          offset: categoryOffset,
          search_term: categoryText,
          status: 1,
        };
        dispatchGetMasterDataClientCategoryAction(finalData);
      }
    },
    500,
    [categoryText]
  );
//  scope of work filter
useEffect(() => {
  const finalScopeOfWorkData = scopeOfWorkList?.map((scope: any) => {
    
    return {
      value: scope?._id,
      label: scope?.scope_of_work_name,
    };
  })
  if (scopeofWorkOffset > 0) {
    setFinalScopeofWorkFilterList([...finalScopeofWorkFilterList, ...finalScopeOfWorkData]);
  } else {
    setFinalScopeofWorkFilterList(finalScopeOfWorkData);
  }
}, [scopeOfWorkList])
useEffect(() => {
  if (token) {
    let finalUserData = {
    token,
    limit:scopeLimit,
    offset:scopeofWorkOffset,
    searchValue: scopeofWorkText,
    status:1
    };
    if (scopeofWorkOffset <= scopeOfWorkTotalCount) {
      dispatchGetMasterDataScopeOfWorkAction(finalUserData)
    }
  }
}, [scopeofWorkOffset])

const fetchScopeOfWorkData = (search: string) => {
  const finalData = {
    token,
    limit:scopeLimit,
    offset:scopeofWorkOffset,
    searchValue: scopeofWorkText,
    status:1
  }
  dispatchGetMasterDataScopeOfWorkAction(finalData)
}

useDebounce(() => {
  if (scopeofWorkText) {
    fetchScopeOfWorkData(scopeofWorkText)
  }
  else {
    const finalData = {
      token,
      limit:scopeLimit,
      offset:scopeofWorkOffset,
      searchValue: scopeofWorkText,
      status:1
    }
    dispatchGetMasterDataScopeOfWorkAction(finalData)
  }
}, 500, [scopeofWorkText]);

  const handleClientCategoryChange = (e: any) => {
    let clientCategoryIdName: any = e?.map((e: any) => {
      return e?.label;
    });
    setHandleState(clientCategoryIdName);
    let totalUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setClientCategoryFilter([...totalUser]);
  };
  const handleScopeOfWorkChange = (e: any) => {
    let scopeofworkIdName: any = e?.map((e: any) => {
      return e?.label;
    });
    setHandleScopeofWorkState(scopeofworkIdName);
    let totalUser = e?.map((e: any) => {
      return {
        value: e?.value,
        label: e?.label,
      };
    });
    setScopeofWorkFilter([...totalUser]);
  };

  const handleBranchChange = (e: any) => {
    setBranchFilter(e);
  }

  useEffect(() => {
    setOffset(0);
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    dispatchResetClientDirectoryList();
    dispatchResetClientDirectoryTotalCount();
    if (
      token &&
      (sortByCc?.name ||
        sortByName?.name ||
        sortByCf?.name ||
        sortByRecent?.name)
    ) {
      let params = {
        token,
        offset,
        limit,
        clientCode: sortByCc?.value,
        name: sortByName?.value,
        clientFrom: sortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        branch_id: branchFilter?.value,
        isView: assignedPathName ? true : false,
        client_category: `${
          !!selectedClientCategoryFilter[0]
            ? selectedClientCategoryFilter?.join()
            : persistCategory
        }`,
        scope_of_work:`${
          !!selectedScopeofWorkFilter[0]
            ? selectedScopeofWorkFilter?.join()
            : persistScope
        }`
      };

      dispatchGetClientDirectoryListAction(params);
    }
  }, [sortByName, sortByCc, sortByCf]);

  useEffect(() => {
    dispatchResetClientDirectoryList();
    if (
      persistSortByCc?.name ||
      persistSortByCf?.name ||
      persistSortByName?.name
    ) {
      dispatchResetClientDirectoryList();
      if (persistSortByCc?.name) {
        setSortByCc({
          ...persistSortByCc,
        });
        setSortByCf({ name: "", value: "" });
        setSortByName({ name: "", value: "" });
      } else if (persistSortByCf?.name) {
        setSortByCf({
          ...persistSortByCf,
        });
        setSortByCc({ name: "", value: "" });
        setSortByName({ name: "", value: "" });
      } else if (persistSortByName?.name) {
        setSortByName({
          ...persistSortByName,
        });
        setSortByCc({ name: "", value: "" });
        setSortByCf({ name: "", value: "" });
      }
      let finalData = {
        token,
        offset,
        limit,
        clientCode: persistSortByCc?.value,
        name: persistSortByName?.value,
        clientFrom: persistSortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        isView: assignedPathName ? true : false,
        client_category: `${
          !!selectedClientCategoryFilter[0]
            ? selectedClientCategoryFilter?.join()
            : persistCategory
        }`,
        scope_of_work:`${
          !!selectedScopeofWorkFilter[0]
            ? selectedScopeofWorkFilter?.join()
            : persistScope
        }`,
        branch_id: branchFilter?.value ? branchFilter?.value : persistBranchFilter?.value,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  }, [persistSortByCc?.name, persistSortByCf?.name, persistSortByName?.name]);

  useEffect(() => {
    if (showIsClientSendEmailData?.to_email) {
      setClientEmailText(showIsClientSendEmailData?.to_email);
    } else {
      setClientEmailText("");
    }
  }, [showIsClientSendEmailData?.to_email, showIsClientSendEmail]);

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setOffset(0);
    setSearchValue(value);
    if (value?.length === 0) {
      const finalData = {
        token,
        limit,
        offset,
        clientCode: sortByCc?.value ? sortByCc?.value : persistSortByCc?.value,
        name: sortByName?.value ? sortByName?.value : persistSortByName?.value,
        clientFrom: sortByCf?.value ? sortByCf?.value : persistSortByCf?.value,
        searchValue: "",
        isView: assignedPathName ? true : false,
        client_category: `${
          !!selectedClientCategoryFilter[0]
            ? selectedClientCategoryFilter?.join()
            : persistCategory
        }`,
        scope_of_work:`${
          !!selectedScopeofWorkFilter[0]
            ? selectedScopeofWorkFilter?.join()
            : persistScope
        }`,
        branch_id: branchFilter?.value ? branchFilter?.value : persistBranchFilter?.value,
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };
  const handleEditClientDirectory = (clientCode: string) => {
    history?.push({
      pathname: `client-directory-list/edit/${clientCode}`,
      state: {
        clientCode,
        sortByCc,
        sortByName,
        sortByCf,
        searchValue,
        selectedClientCategoryFilter,
        clientCategoryFilter,
        selectedScopeofWorkFilter,
        scopeofWorkFilter,
        branchFilter
      },
    });
  };
  const handleViewClientDirectory = (clientCode: string) => {
    history?.push({
      pathname: `assigned-client-directory/view/${clientCode}`,
      state: {
        clientCode,
        sortByCc,
        sortByName,
        sortByCf,
        searchValue,
        selectedClientCategoryFilter,
        clientCategoryFilter,
        selectedScopeofWorkFilter,
        scopeofWorkFilter,
        branchFilter
      },
    });
  };

  const handleSort = (data: any) => {
    setOffset(0);
    dispatchResetClientDirectorySuccess();
    dispatchResetClientDirectoryError();
    dispatchResetClientDirectoryMessage();
    dispatchResetClientDirectoryStatusCode();
    dispatchResetClientDirectoryList();
    dispatchResetClientDirectoryTotalCount();
    if (
      data?.name === "Client Code - Ascending" ||
      data?.name === "Client Code - Descending"
    ) {
      setSortByCc(data);
      setSortByName({ name: "", value: "" });
      setSortByCf({ name: "", value: "" });
      setSortByRecent({ name: "", value: "" });
    } else if (
      data?.name === "Client From - Ascending" ||
      data?.name === "Client From - Descending"
    ) {
      setSortByCf(data);
      setSortByName({ name: "", value: "" });
      setSortByCc({ name: "", value: "" });
      setSortByRecent({ name: "", value: "" });
    } else if (
      data?.name === "Name - A to Z Order" ||
      data?.name === "Name - Z to A Order"
    ) {
      setSortByName(data);
      setSortByCc({ name: "", value: "" });
      setSortByCf({ name: "", value: "" });
      setSortByRecent({ name: "", value: "" });
    } else if (data?.name === "Recently added") {
      setSortByName({ name: "", value: "" });
      setSortByCc({ name: "", value: "" });
      setSortByCf({ name: "", value: "" });
      setSortByRecent(data);
    }
  };
  const handleFilter = (data: any) => {
    setSelectedFilter({
      name: data?.name,
      value: data?.value,
    });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientDirectoryError();
            }}
          />
        );
      }
    }
    if (clientStatusSuccess === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={clientStatusSuccess === 1}
          title="Success"
          message={`Client ${
            clientStatusData?.is_active === 0 ? "Enabled" : "Disabled"
          } Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetClientDirectoryList();
            if (token) {
              setClientStatusData({
                name: "",
                clientCode: null,
                is_active: null,
              });
              if (offset === 0) {
                if (token) {
                  let finalData = {
                    token,
                    offset,
                    limit,
                    clientCode: sortByCc?.value
                      ? sortByCc?.value
                      : persistSortByCc?.value,
                    name: sortByName?.value
                      ? sortByName?.value
                      : persistSortByName?.value,
                    clientFrom: sortByCf?.value
                      ? sortByCf?.value
                      : persistSortByCf?.value,
                    searchValue: searchValue,
                    contact_type: selectedFilter?.value,
                    isView: assignedPathName ? true : false,
                    client_category: `${
                      !!selectedClientCategoryFilter[0]
                        ? selectedClientCategoryFilter?.join()
                        : persistCategory
                    }`,
                    scope_of_work:`${
                      !!selectedScopeofWorkFilter[0]
                        ? selectedScopeofWorkFilter?.join()
                        : persistScope
                    }`,
                    branch_id: branchFilter?.value ? branchFilter?.value : persistBranchFilter?.value,
                  };

                  dispatchGetClientDirectoryListAction(finalData);
                }
              } else {
                dispatchResetClientDirectoryList();
                setOffset(0);
              }
            }
            dispatchResetClientStatusSuccess();
          }}
        />
      );
    } else if (
      success === 1 &&
      message === "Client thank you mail has been sent successfully."
    ) {
      toast.success("Client thank you mail has been sent successfully.", {
        duration: 2000,
      });
      dispatchResetClientDirectoryMessage();
      dispatchResetClientStatusSuccess();
    }
  };

  const handleChangeClientStatus = () => {
    if (token && clientStatusData?.clientCode) {
      const finalData = {
        token,
        clientCode: clientStatusData?.clientCode,
        status: clientStatusData?.is_active === 0 ? 1 : 0,
      };
      dispatchChangeClientStatusAction(finalData);
    }
  };

  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };
  const handleChangeClientStatusChangeData = (data: any) => {
    setClientStatusData({
      name: data?.company_name,
      is_active: data?.is_active,
      clientCode: data?.client_code,
    });
  };

  const handleSentEmailToClient = (data: SendEmailPayload) => {
    // setShowIsLeadSendEmail(!showIsLeadSendEmail);
    dispatchResetLeadEmailHistory();
    setShowIsClientSendEmailData({
      to_email: data?.to_email ? data?.to_email : "",
      client_code: data?.client_code,
    });
    if (data?.to_email) {
      let finalData = {
        email: data?.to_email,
        client_code: data?.client_code,
        template_name: "client_thank_you_email",
        token,
      };
      dispatchEmailHistoryAction(finalData);
    }
    // if (data.to_email && data.to_email && token) {
    //   let finaData = {
    //     token,
    //     ...data,
    //   };
    //   dispatchSentEmailAction(finaData);
    // }
  };
  const handleToggleSentEmailToClient = () => {
    setShowIsClientSendEmail(!showIsClientSendEmail);
    setIsEmailError("");
  };

  const handleSendEmail = (data: SendEmailPayload) => {
    if (
      showIsClientSendEmailData?.to_email &&
      token &&
      showIsClientSendEmailData?.client_code
    ) {
      let finaData = {
        token,
        to_email: clientEmailText,
        client_code: showIsClientSendEmailData?.client_code,
      };
      dispatchSentEmailAction(finaData);
    }
    handleToggleSentEmailToClient();
  };
  const handleCategoryFilter = (type?: string, handleState?: any, handleScopeofWorkState?:any) => {
    delete history?.location?.state?.persistCategory;
    delete history?.location?.state?.persistcategoryFilter;
    delete history?.location?.state?.persistScope;
    delete history?.location?.state?.persistScopeFilter;
    delete history?.location?.state?.persistBranchFilter;
    setOffset(0);
    if (type != "clear") {
      setFilter(selectedClientCategoryFilter.join(","));
      setFilter(selectedScopeofWorkFilter.join(","));
      setFilter(branchFilter?.value);
    }
   
    if (token) {
      let finalData = {
        token,
        offset,
        limit,
        clientCode: sortByCc?.value ? sortByCc?.value : persistSortByCc?.value,
        name: sortByName?.value ? sortByName?.value : persistSortByName?.value,
        clientFrom: sortByCf?.value ? sortByCf?.value : persistSortByCf?.value,
        searchValue: searchValue,
        contact_type: selectedFilter?.value,
        isView: assignedPathName ? true : false,
        branch_id:type==="clear" ?null : branchFilter?.value? branchFilter?.value:persistBranchFilter?.value,
        client_category:
          type === "clear"
            ? null
            : `${!!handleState[0] ? handleState?.join() : persistCategory}`,
        scope_of_work:type==="clear"?null:`${!!handleScopeofWorkState[0] ? handleScopeofWorkState?.join() : persistScope}`
      };

      dispatchGetClientDirectoryListAction(finalData);
    }
  };
  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <CommonHeader title="Client Directory" />
        </div>
      </div>
      <div
        style={{
          backgroundColor: "white",
          paddingTop: "23px",
          border: "1px solid #bfcbe1",
          borderRadius: "6px",
        }}
      >
        <div className="row">
          <div className="col-md-12 d-flex justify-content-between">
            <div className="col-md-4 ml-3" style={{ padding: 0 }}>
              <div
                className="d-flex flex-column"
                style={{ justifyContent: "center", alignItems: "flex-start" }}
              >
                <h6 style={{ fontSize: "18px", fontWeight: 500 }}>
                  Client Directory List
                </h6>
                <div
                  style={{
                    color: "rgb(124, 141, 176)",
                    fontSize: "13px",
                    fontWeight: 500,
                  }}
                >
                  Total {totalCount ? totalCount : 0} entries found
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end col-md-8">
              <div className="col-md-4">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
              <div className="mr-2">
                <ClientDirectoryFilter
                  clientCategoryFilter={clientCategoryFilter}
                  finalCategoryFilterList={finalCategoryFilterList}
                  handleClientCategoryChange={handleClientCategoryChange}
                  setCategoryOffset={setCategoryOffset}
                  setCategoryText={setCategoryText}
                  loginData={loginData}
                  fetching={fetching}
                  categoryLimit={categoryLimit}
                  setClientCategoryFilter={setClientCategoryFilter}
                  handleFilter={handleCategoryFilter}
                  filter={filter}
                  setFilter={setFilter}
                  selectedClientCategoryFilter={selectedClientCategoryFilter}
                  setSelectedClientCategoryFilter={
                    setSelectedClientCategoryFilter
                  }
                  setOffset={setOffset}
                  history={history}
                  apply={apply}
                  setApply={setApply}
                  setHandleState={setHandleState}
                  handleState={handlestate}
                  scopeofWorkFilter={scopeofWorkFilter}
                  finalScopeofWorkFilterList={finalScopeofWorkFilterList}
                  handleScopeOfWorkChange={handleScopeOfWorkChange}
                  setscopeofWorkOffset={setscopeofWorkOffset}
                  setLocationOffset={setLocationOffset}
                  locationOffset={locationOffset}
                  setScopeofWorkText={setScopeofWorkText}
                  setLocationText={setLocationText}
                  locationText={locationText}
                  scopeLimit={scopeLimit}
                  setScopeofWorkFilter={setScopeofWorkFilter}
                  selectedScopeofWorkFilter={selectedScopeofWorkFilter}
                  setSelectedScopeofWorkFilter={
                    setSelectedScopeofWorkFilter
                  }
                  // handleScopeofWorkFilter={handleScopeofWorkFilter}
                  handleScopeofWorkState={handleScopeofWorkState}
                  setHandleScopeofWorkState={setHandleScopeofWorkState}
                  branchFinalData={branchFinalData}
                  handleBranchChange={handleBranchChange}
                  branchFilter={branchFilter}
                  setBranchFilter={setBranchFilter}
                  locationLimit={locationLimit}
                  filterCount={filterCount} 
                  setFilterCount={setFilterCount}
                />
              </div>
              <div className={!isAddClientPresent ? "mr-3" : ""}>
                <ClientDirectoryListSorting
                  data={data}
                  handleChange={handleSort}
                  selectedData={
                    sortByName?.value
                      ? sortByName
                      : sortByCc?.value
                      ? sortByCc
                      : sortByCf
                  }
                />
              </div>
              <div className={!isAddClientPresent ? "mr-3" : ""}></div>
              {isDownloadReportPresent && !isViewOnlyClientPresent ? (
                <div className={isAddClientPresent ? "ml-2 mr-2" : "mr-2"}>
                  <ClientDownloadReport token={token} />
                </div>
              ) : (
                ""
              )}
              {isAddClientPresent && clientDirectoryListData?.length > 0 && (
                <div className="col-md-3 d-flex justify-content-start">
                  <div className="justify-content-start">
                    <button
                      onClick={() =>
                        history?.push({
                          pathname: `client-directory-list/add`,
                        })
                      }
                      className="btn btn-primary"
                    >
                      + Add Client
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {fetching && offset === 0 ? (
          <TableLoader Rows={10} ColumnPerRow={7} />
        ) : clientDirectoryListData?.length > 0 ? (
          <ClientDirectoryTable
            offset={offset}
            fetching={fetching}
            handleConfirmationModal={handleConfirmationModal}
            handleChangeClientStatusChangeData={
              handleChangeClientStatusChangeData
            }
            clientDirectoryList={clientDirectoryListData}
            tableHeader={CLIENT_DIRECTORY_HEADERS}
            handleEditClientDirectory={handleEditClientDirectory}
            handleViewClientDirectory={handleViewClientDirectory}
            isEditClientPresent={isEditClientPresent}
            isViewClientPresent={isViewClientPresent}
            isViewOnlyClientPresent={isViewOnlyClientPresent}
            handleToggleSentEmailToClient={handleToggleSentEmailToClient}
            handleSentEmailToClient={handleSentEmailToClient}
            handleSendEmail={handleSendEmail}
            isEmailClientPresent={isEmailClientPresent}
          />
        ) : (
          fetching === false &&
          clientDirectoryListData?.length === 0 && (
            <div className="mt-5">
              <EmptyListPage
                title="No Client List Found"
                image={EmptyClientList}
                imageWidth="30%"
                buttonTitle={
                  assignedPathName
                    ? ""
                    : isAddClientPresent
                    ? "+ Add Client"
                    : ""
                }
                showLinkButton={
                  assignedPathName ? false : isAddClientPresent ? true : false
                }
                link={`client-directory-list/add`}
              />
            </div>
          )
        )}
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          toggle={() => {
            handleConfirmationModal();
            setClientStatusData({
              name: "",
              clientCode: null,
              is_active: null,
            });
          }}
          isOpen={showConfirmationModal}
          title={`${
            clientStatusData?.is_active === 0 ? "Enable" : "Disable"
          } Client?`}
          message={`Are you sure you want to ${
            clientStatusData?.is_active === 0
              ? `enable ${clientStatusData?.name}`
              : `disable ${clientStatusData?.name}`
          }?`}
          confirmButtonText={
            clientStatusData?.is_active === 1 ? "Disable" : "Enable"
          }
          onPressConfirm={() => {
            handleChangeClientStatus();
            handleConfirmationModal();
          }}
        />
      )}
      {showIsClientSendEmail && (
        <ClientModuleEmailModal
          modal={showIsClientSendEmail}
          toggleModal={handleToggleSentEmailToClient}
          data={leadClientEmailHistory}
          leadEmailText={clientEmailText}
          setClientEmailText={setClientEmailText}
          handleSendEmail={handleSendEmail}
          isEmailError={isEmailError}
          setIsEmailError={setIsEmailError}
        />
      )}
      <Toaster />
      {handleErrorModal()}
      {emailFetching && <Loader />}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientDirectory.success,
  fetching: state.clientDirectory.fetching,
  message: state.clientDirectory.message,
  statusCode: state.clientDirectory.statusCode,
  error: state.clientDirectory.error,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  totalCount: state.clientDirectory.totalCount,
  clientStatusSuccess: state.clientDirectory.clientStatusSuccess,
  loginData: state.auth.loginData,
  leadClientEmailHistory: state.clientDirectory.leadClientEmailHistory,
  emailFetching: state.clientDirectory.emailFetching,
  clientCategoryList: state.masterData.clientCategoryList,
  clientCategoryTotalCount: state.masterData.clientCategoryTotalCount,
  scopeOfWorkList: state.masterData.scopeOfWorkList,
  scopeOfWorkTotalCount: state.masterData.scopeOfWorkTotalCount,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  masterDataListing: state.masterData.masterDataListing,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetClientDirectorySuccess: () =>
    dispatch(resetClientDirectorySuccess()),
  dispatchResetClientDirectoryError: () =>
    dispatch(resetClientDirectoryError()),
  dispatchResetClientDirectoryMessage: () =>
    dispatch(resetClientDirectoryMessage()),
  dispatchResetClientDirectoryStatusCode: () =>
    dispatch(resetClientDirectoryStatusCode()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetClientStatusSuccess: () => dispatch(resetClientStatusSuccess()),
  dispatchResetClientDirectoryList: () => dispatch(resetClientDirectoryList()),
  dispatchResetClientDirectoryTotalCount: () =>
    dispatch(resetClientDirectoryTotalCount()),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchChangeClientStatusAction: (
    data: ChangeClientStatusChangePayloadType
  ) => dispatch(changeClientStatusAction(data)),
  dispatchSentEmailAction: (data: SendEmailPayload) =>
    dispatch(clientSentEmailAction(data)),
  dispatchEmailHistoryAction: (data: EmailHistoryPayload) =>
    dispatch(leadClientSentEmailHistoryAction(data)),

  dispatchResetLeadEmailHistory: () => dispatch(resetLeadClientEmailHistory()),
  dispatchResetLeadEmailFetching: () => dispatch(resetLeadEmailFetching()),
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => dispatch(getMasterDataClientCategoryAction(data)),
  dispatchGetMasterDataScopeOfWorkAction: (
    data: GetUsersDepartmentPayloadType
  ) => dispatch(getMasterDataScopeOfWorkAction(data)),

  dispatchGetAllMasterDataBranchListAction: (data: GetAllMasterDataBranchPayloadType) => {
    dispatch(getAllMasterDataBranchAction(data))
  },
  dispatchResetMasterDataListing: () => dispatch(resetMasterDataLisitng()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientDirectory);
